import React, { useState } from "react";

import "./form1.css";
import { useNavigate } from "react-router-dom";
import { Notify } from "notiflix";
import axios from "axios";
import { Loading } from "notiflix";
const Form1 = ({ formData, setFormData, step, setStep }) => {
  console.log("formdata", formData);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    setErrors({ ...errors, [name]: "" }); 
  };

  const validate = () => {

    const newErrors = {};

    if (!formData.registeredBy) newErrors.registeredBy = "required";
    if (!formData.name) newErrors.name = "required";
    if (!formData.gender) newErrors.gender = "required";
    if (!formData.dobDay) newErrors.dobDay = "required";
    if (!formData.dobMonth) newErrors.dobMonth = "required";
    if (!formData.dobYear) newErrors.dobYear = "required";
    if (!formData.birthHour) newErrors.birthHour = "required";
    if (!formData.birthMinute) newErrors.birthMinute = "required";
    if (!formData.birthAmPm) newErrors.birthAmPm = "required";
    if (!formData.birthPlace) newErrors.birthPlace = "required";
    if (!formData.maritalStatus) newErrors.maritalStatus = "required";

    if (!formData.mobile) {
      newErrors.mobile = "required";
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Enter valid 10-digit number";
    }

    if (!formData.alternateMobile) {
      newErrors.alternateMobile = "required";
    } else if (!/^\d{10}$/.test(formData.alternateMobile)) {
      newErrors.alternateMobile = "Enter valid 10-digit number";
    }

    return newErrors;
  };

  const HandleNext = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      Loading.standard('Loading...');

      axios.post('https://kovaikongunadumatrimony.com/kkm_backend/public/api/check-exisiting-user', {
        mobile_number: formData.mobile
      }).then(response => {

        if (response.data.status == true) {
          setStep(2);
          Loading.remove();

        } else {
          Notify.failure(response.data.message);
          Loading.remove();
        }
      });
    }
  };

  return (
    <>
      <div className="form-background">
        <div className="form-section">
          <h2 className="form-title">
            Create Your Account
            <h5 className="text-success"><b>Kongu Vellalar community only</b></h5>
            (Birth Details(1/7))
          </h2>
          <form>
            <div className="form-row">
              <div className="form-group half-width">
                <label>
                  <b>
                    Registered By<span className="error fs-star">*</span>
                  </b>
                </label>
                <select
                  name="registeredBy"
                  value={formData.registeredBy}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="Father">Father</option>
                  <option value="Mother">Mother</option>
                  <option value="Friend">Friend</option>
                  <option value="Other">Other</option>
                </select>
                {errors.registeredBy && (
                  <p className="error">{errors.registeredBy}</p>
                )}
              </div>

              <div className="form-group half-width">
                <label>
                  <b>
                    Full Name<span className="error fs-star">*</span>
                  </b>
                </label>
                <input
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && <p className="error">{errors.name}</p>}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group half-width">
                <label>
                  <b>
                    Gender<span className="error fs-star">*</span>
                  </b>
                </label>
                <select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
                {errors.gender && <p className="error">{errors.gender}</p>}
              </div>

              <div className="form-group half-width">
                <label>
                  <b>
                    Marital Status<span className="error fs-star">*</span>
                  </b>
                </label>
                <select
                  name="maritalStatus"
                  value={formData.maritalStatus}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="Unmarried">Unmarried</option>
                  <option value="married">Married</option>
                  <option value="divorced">Divorced</option>
                  <option value="widowed">Widowed</option>
                </select>
                {errors.maritalStatus && (
                  <p className="error">{errors.maritalStatus}</p>
                )}
              </div>
            </div>

            <div className="form-group full-width">
              <label>
                <b>
                  Date of Birth<span className="error fs-star">*</span>
                </b>
              </label>
              <div className="dob-selects">
                <div>
                  <select
                    name="dobDay"
                    value={formData.dobDay}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">Day</option>
                    {Array.from({ length: 31 }, (_, i) => {
                      const day = String(i + 1).padStart(2, "0");
                      return (
                        <option key={day} value={day}>
                          {day}
                        </option>
                      );
                    })}
                  </select>
                  {errors.dobDay && <p className="error">{errors.dobDay}</p>}
                </div>
                <div>
                  <select
                    name="dobMonth"
                    value={formData.dobMonth}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">Month</option>
                    {Array.from({ length: 12 }, (_, i) => {
                      const month = String(i + 1).padStart(2, "0");
                      return (
                        <option key={month} value={month}>
                          {month}
                        </option>
                      );
                    })}
                  </select>
                  {errors.dobMonth && (
                    <p className="error">{errors.dobMonth}</p>
                  )}
                </div>
                <div>
                  <select
                    name="dobYear"
                    value={formData.dobYear}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">Year</option>
                    {Array.from({ length: new Date().getFullYear() - 1951 + 1 }, (_, i) => {
                      const year = 1951 + i;
                      return (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      );
                    })}
                  </select>
                  {errors.dobYear && <p className="error">{errors.dobYear}</p>}
                </div>
              </div>
            </div>

            <div className="form-group full-width mt-4">
              <label>
                <b>
                  Birth Time<span className="error fs-star">*</span>
                </b>
              </label>
              <div className="time-selects">
                <div>
                  <select
                    name="birthHour"
                    value={formData.birthHour}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">Hour</option>
                    {Array.from({ length: 13 }, (_, i) => {
                      const hour = String(i).padStart(2, "0");
                      return (
                        <option key={hour} value={hour}>
                          {hour}
                        </option>
                      );
                    })}
                  </select>
                  {errors.birthHour && (
                    <p className="error">{errors.birthHour}</p>
                  )}
                </div>
                <div>
                  <select
                    name="birthMinute"
                    value={formData.birthMinute}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">Minute</option>
                    {Array.from({ length: 59 }, (_, i) => {
                      const minute = String(i).padStart(2, "0");
                      return (
                        <option key={minute} value={minute}>
                          {minute}
                        </option>
                      );
                    })}
                  </select>
                  {errors.birthMinute && (
                    <p className="error">{errors.birthMinute}</p>
                  )}
                </div>
                <div>
                  <select
                    name="birthAmPm"
                    value={formData.birthAmPm}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">AM/PM</option>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                  {errors.birthAmPm && (
                    <p className="error">{errors.birthAmPm}</p>
                  )}
                </div>
              </div>
            </div>

            <div className="form-row mt-4">
              <div className="form-group half-width">
                <label>
                  <b>
                    Birth Place<span className="
                     fs-star">*</span>
                  </b>
                </label>
                <input
                  type="text"
                  name="birthPlace"
                  placeholder="Birth place"
                  value={formData.birthPlace}
                  onChange={handleChange}
                />
                {errors.birthPlace && (
                  <p className="error">{errors.birthPlace}</p>
                )}
              </div>
              <div className="form-group half-width">
                <label>
                  <b>
                    Mobile Number<span className="error fs-star">*</span>
                  </b>
                </label>
                <input
                  type="tel"
                  name="mobile"
                  placeholder="Enter Mobile number"
                  value={formData.mobile}
                  onChange={handleChange}
                />
                {errors.mobile && <p className="error">{errors.mobile}</p>}
              </div>
            </div>

            <div className="form-group">
              <label>
                <b>
                  Alternate Mobile Number<span className="error fs-star">*</span>
                </b>
              </label>
              <input
                type="tel"
                name="alternateMobile"
                placeholder="Enter Alter mobile number"
                value={formData.alternateMobile}
                onChange={handleChange}
                maxLength={10}
                pattern="\d*"
              />
              {errors.alternateMobile && (
                <p className="error">{errors.alternateMobile}</p>
              )}
            </div>

            <button
              type="button"
              onClick={HandleNext}
              className="submit-btn-1 mt-4"
            >
              Continue
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Form1;
